import tokenKeeper from '@/lib/apiTokenKeeper';

// Payment API needs the username (from env.userId) and the pay-module account
// id (from payModuleCompanyPermissions) as headers. Thin adapters over the
// existing tokenKeeper, mirroring auth.ts/companyId.ts.
export const getUsername = (): string => tokenKeeper.getUsername();
export const getAccountId = (): string => tokenKeeper.getAccountId();
